<template>
  <div class="select-address-cascader">
    <el-cascader
        size="small"
        :props="props"
        v-model="address_list"
        :options="$store.state.regionData"
        :disabled="disabled"
        @change="handleChange"
    />
  </div>
</template>

<script>

import axios from "axios";
export default {
  name: "selectAddressCascader",
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.address_list = JSON.parse(JSON.stringify(this.$props.value));
    this.getData();
  },
  watch: {
    value: {
      handler(n) {
        if (!this.is_Empty(n)) {
          this.address_list = [];
          n.forEach(el => {
            this.address_list.push(el);
          })
        }
      },
      deep: true
    },
  },
  data() {
    return {
      props: {
        value: "label",
      },
      address_list: this.$props.value
    }
  },
  methods: {
    async getData() {
      if (this.is_Empty(this.$store.state.regionData)) {
        let res = await axios.get('https://img.beltdance.com/app/static/customize.json');
        this.$store.commit('SET', {
          key: 'regionData',
          value: res.data
        })
      }
    },
    handleChange(item) {
      this.$emit('input', item);
    }
  }
}
</script>

<style scoped lang="scss">
.select-address-cascader {
  width: 100%;
  height: 100%;

  .el-cascader {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/selectAddressCascader.vue